import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";
import pagination from "./pagination.js";
import MarkerClusterer from "@google/markerclustererplus";
import Slider from './Slider.js';
import lozad from 'lozad';
import noUiSlider from 'nouislider';
import { InputQuantity } from './components/InputQuantity.js';
import { param } from "jquery";
// skinuti kasnije novi clusterer sejvao u Tools bookmark

const list = {
    // references
    $form: null,
    form: null,
    noHover: false,
    $moreFiltersBtns: null,
    $moreFiltersBtnsIcons: null,
    moreFilters: false,
    $moreFiltersContainer: null,
    $shownItems: null,
    $total: null,
    $body: {},
    $list: null,
    list: null,
    $listWrap: null,
    $map: null,
    map: null,
    infoWindow: null,
    cluster: null,
    lastEvent: null,
    // form params
    params: {},
    defaults: {
        dateFrom: '',
        dateTo: '',
        ms: '',
        objectTypeId: '',
        guests: '2,0',
        personsInObject: '',
        sortBy: 0,
        _page: 1,
        perPage: 20,
        rooms: '',
        roomsExact: '',
        //themeId: '',
        tagCategoryId: '',
        //tagCategoryIds: '',
        distanceBeach: '',
        distanceCenter: '',
        objectId: '',
        hydromassageBathtub: '',
        objectName: '',
        parking: '',
        pool: '',
        pets: '',
        grill: '',
        seaView: '',
        heatedPool: '',
        ac: '',
        satTV: '',
        internet: '',
        disabledPersons: '',
        washingMachine: '',
        coordinates: '',
        bathrooms: '',
        template: '',
        price: '0,20000',
        pricePaymentTypeKey: 'perUnitPerWeek',
        hasDiscount: '',
        language: functions.getLang(),
        currencyIdTo: functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1
    },
    mainFields: ['dateFrom', 'dateTo', 'dates', 'ms', 'objectTypeId', 'guests', 'personsInObject', 'sortBy', '_page'],
    secondaryFieldsDesktop: ['dateFrom', 'dateTo', 'dates', 'ms', 'objectTypeId', 'guests', 'personsInObject', 'sortBy', '_page', 'perPage', 'coordinates', 'currencyIdTo'],
    secondaryFieldsMobile: ['objectTypeId', 'personsInObject', 'sortBy', '_page', 'perPage', 'coordinates', 'currencyIdTo'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: false,
    disabledFields: {'pool' : true},
    locations: null,
    pauseDestination: false,
    preselect: null,
    $filterClearTemplate: null,
    $filterClearMobileTemplate: null,
    $formGuide: null,
    $formGuideDefaultPlaceholder: null,
    $formGuideCoordinatesPlaceholder: null,
    //destinationsData: null,

    // methods
    // get URL params and merge with defaults
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getUrlData(true));
        //  Added bcs in from input field name is dates but Render acepts datefrom and dateTo
        if (list.params.dateFrom && list.params.dateTo) list.params.dates = list.params.dateFrom + ' - ' + list.params.dateTo;   
        if (list.preselect) list.params.ms = list.preselect;   
        //if (list.params.rooms && list.params.rooms > 0 && list.params.rooms < 5) { list.params.roomsExact = list.params.rooms; list.params.rooms = list.defaults.rooms; }
        
        list.params.pets = list.params.pets ? list.params.pets.split(',')[0] : list.params.pets;

        // if (list.params.language == 'cs') list.params.language = 'cz';
        list.setFiltersCount();
        
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            params.dates = null;
        }

        return
    },
    // on form fields change set URL which will trigger load mode
    onChange(e) {
        list.preselect = null;
        clearTimeout(list.changeTimeout);
        
        if ( list.pauseChange ) {
            return;
        }
        // if changed field is date range and not have dateFrom & dateTo prevent url push
        if ( e && e.target.name == 'dates' ) {
            let val = e.target.value.split(' - ');

            if (val.length == 2) $('.dates-clear').removeClass('d-none');
            
            // when date clear it has one empty element 
            if ( val.length != 2 && val[0] != '') {
                return;
            }
        }
        // for case when coordinates are in url and destination is picked, coordinates need to be cleared, can't have both in url
        if ( e && e.target.name == 'ms') {
            // if (e.target.value == list.params.ms) return;
            if(list.params.ms == '' && list.params.coordinates != '') {
                list.params.coordinates = ''; 
            }
        }

        // 
        if( e && list.mainFields.indexOf(e.target.name) === -1)
        {
            return;
        }

        // not advanced (ajax) search
        if ( !list.$body.length ) {
            return;
        }

        list.noHover = true;
        list.changeTimeout = setTimeout(() => {
            functions.setUrlData(list.getFormData(), list.$body.length, false, list.defaults);
        }, 300);
    },
    getFormData() {
        let formData = $.extend(
                functions.getFormData(list.$form),
                {
                    coordinates: list.params.coordinates,
                    _page: list.paginated ? list.params._page : 1,
                    sortBy: list.paginated ? list.params.sortBy : 0
                }
        );
        list.paginated = false;

        list.$form.find('.input-number').each((index, elem) => {
            const $elem = $(elem);
            const value = +$elem.val();
            const name = $elem.attr('name');

            if(value) formData[name] = value;
        });

        // do not send same values as defaults
        $.map(formData, (val, key) => {
            if ( list.defaults[key] == val || !val ) {
                delete formData[key];
            }
        });
        
        return formData;
    },
    init() {
        list.$form = $('.search-form');
        if ( !list.$form.length ) {
            return;
        }
        
        list.$body = $('.body-listing');

        list.setPriceSliderAndSliderCurrency();

        // register form submit
        list.$form.on('submit', e => {
            e.preventDefault();
            if ( list.$body.length ) {
                list.onChange();
                list.toggleMobileForm(false);
            } else {
                // non ajax form
                let data = $.param(list.getFormData()),
                toHash = list.$form.hasClass('form-hash');
                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if ( data ) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                if( list.$body.length ) list.toggleFilters(false);
                location.href = href;
            }
        });
        list.preselect = list.$form.attr('data-preselect');
        if (list.preselect) list.preselect = JSON.parse(list.preselect);
        
        list.form = list.$form[0];

        list.$formGuide = $('.form-guide');
        list.$formGuideDefaultPlaceholder = list.$formGuide.attr('data-placeholder');
        list.$formGuideCoordinatesPlaceholder = list.$formGuide.attr('data-coordsplaceholder');        
        
        list.$moreFiltersBtns = list.$form.find('.more-filters');
        list.$moreFiltersBtnsIcons = list.$moreFiltersBtns.find('i');
        list.$filtersCount = list.$moreFiltersBtns.find('.filters-count');
        list.$moreFiltersContainer = $('.more-filters-container');
        
        // for filters on mobile
        //let destData = $('[name="ms"]').attr('data-data');
        //list.destinationsData = JSON.parse(destData);
        
        $('#fullscreen').on('click tap vclick', function() {
            $('.list').addClass('hide-list-list');
            $('.map-and-filters').addClass('d-none');
            $('.map-close-btn').removeClass('d-none');
            $('.list-map').addClass('show-map-list');
            $('.list-wrap').addClass('list-wrap-overflow');
        });
        
        $('#close-map').on('click tap vclick', function() {
            $('.list').removeClass('hide-list-list');
            $('.map-and-filters').removeClass('d-none');
            $('.map-close-btn').addClass('d-none');
            $('.list-map').removeClass('show-map-list');
            $('.list-wrap').removeClass('list-wrap-overflow');
        });
        
        
        list.$shownItems = $('.list-shown-items');
        list.$total = $('.list-total');
        
        list.setDisabledFields();
        list.getParams();

        if ( ! $('.list-map').length) {
            list.params = $.extend({}, list.params, list.getFormData());
        }
        
        if (list.params.dates) $('.dates-clear').removeClass('d-none');
        if (list.params.guests !== list.defaults.guests) $('.guests-clear').removeClass('d-none');

        // if (list.params.ms) $('.ms-clear').removeClass('d-none');
        
        $('.dates-clear').on('click', function(e) {
            $('.dates-clear').addClass('d-none');
        })

        $('[name="guests"]').on('change', e => {
           if ($(e.target).val() !== list.defaults.guests) $('.guests-clear').removeClass('d-none');
        })
        
        $('.guests-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            list.params.guests = list.defaults.guests;
            $('.guests-clear').addClass('d-none');
            $(list.form.guests).val(list.params.guests).trigger('change');
        });
        
        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            list.params.ms = '';
            $(list.form.ms).val('').trigger('change');
        });

        $('#filtersModal').on('shown.bs.modal', e => {
            $('.input-quantity-number').each((index, elem) => {
                if (! elem._instance) {
                    const inputName = $(elem).attr('data-inputname');  
                    if(this.params[inputName]) $(elem).attr('data-currentValue', this.params[inputName]);
                    elem._instance = new InputQuantity(elem);
                }
            });
        });

        // if (list.preselect) 
        // {   
        //     // let params = JSON.parse(list.preselect);
        //     // let all = params.split('&');
        //     // let newParams = {};
        //     // all.map( function(param) {
            //     //     let a = param.split('=');
            //     //     newParams[a[0]] = a[1];
            //     // })
            //     list.params.ms = '45.3376197,14.305196|p';
        //     functions.setFormData(list.form, list.params);
        // }
        // delete list.params.ms;
        functions.setFormData(list.form, list.params);
        
        //  This is here bcs new destination componenet dosen't open correctly it we don't exit list.js
        //  but first we need to set FORM DATA bcs of preselect destination on landing pages
        // if (!list.$body.length) return;

        list.$body.length && list.find();
        
        list.registerSearchOpenEvents();

        // register form fields changes
        list.$form.on('change', list.onChange);

        const $petsFields = list.$form.find('[name="pets"]');

        $('[name="pets"]').on('change', e => {
            const $target = $(e.currentTarget);
            const targetId = $target.attr('id');
            const isChecked = $target.is(':checked');

            $petsFields.each((index, petsField) => {
                if (targetId != petsField.id) petsField.checked = isChecked;
            });
        });

        // register hashchange which trigger load
        $(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                //console.log(list.params.pets);
                functions.setFormData(list.form, list.params);
                list.find();
                list.$formGuide.attr('placeholder', list.$formGuideDefaultPlaceholder);
                // here or in component config
                list.params.coordinates && list.$formGuide.attr('placeholder', list.$formGuideCoordinatesPlaceholder);
                list.pauseChange = false;
            }, 100);
        });

        // register sort
        $('[name="sortBy"]').on('change', e => {
            list.params._page = 1;
            list.params.sortBy = $(e.target).val();
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true, false, list.defaults);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        // register paginate        
        $(document).on('click', '.pagination a[data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        // more filters actions
        list.$moreFiltersBtns.on('click', list.toggleFilters);
        list.$moreFiltersContainer.find('.apply-filters').on('click', () => {
            list.toggleFilters(false);
            if ( list.$body.length ) {
                list.onChange();
            } else {
                list.$form.submit();
            }
        });
        // show list item on map
        if ( list.$list ) {
            list.suppressMapEvents = true;
            list.$list.on('mouseenter', '.show-on-map', e => {
                e.stopPropagation();
                e.preventDefault();
                const $this = $(e.currentTarget);
                const objectId = +$this.attr('data-objectId');
                const marker = list.markers.filter(marker => marker.objectId === objectId)[0];
                // list.map.setCenter(marker.position);
                // list.map.setZoom(15);                
                google.maps.event.trigger(marker, 'click');
            });
        }
        // mobile logic
        $('.form-trigger').on('click', () => {
            list.toggleMobileForm(true);
        });
        $('.form-close').on('click', () => {
            list.toggleMobileForm(false);
        });
        // show map button only after list srolled a bit
        if ( list.$list) {
            let listScrollTimeout = 0;
            list.$listWrap.on('scroll', e => {
                clearTimeout(listScrollTimeout);
                listScrollTimeout = setTimeout(() => list.$body.toggleClass('list-scrolled', list.$listWrap.scrollTop() > 300), 50);
            });
            if ( ! functions.isMobile()) 
            {
                list.$listWrap.on('click', '.btn-show-map', e => {

                    list.$listWrap.animate({ scrollTop: 0 });
                });
            }
        }

        

    },
    setDisabledFields() {
        let disabledFields = list.$form.attr('data-disabledFields');
        if ( disabledFields ) {
            disabledFields = JSON.parse(disabledFields);
            $.map(disabledFields, (value, name) => {
                if ( list.form[name] ) {
                    list.disabledFields[name] = true;
                    list.defaults[name] = value;
                    list.form[name].disabled = true;
                    if ( name == 'dateFrom' || name == 'dateTo' ) {
                        $(list.form[name]).next().prop('disabled', true);
                    }
                }
            });
        }
    },
    toggleFilters(toggle) {
        list.moreFilters = toggle === undefined ? !list.moreFilters : toggle;
        list.$moreFiltersBtns.toggleClass('active', list.moreFilters);
        list.$moreFiltersBtnsIcons.toggleClass('fa-chevron-up', list.moreFilters);
        list.$moreFiltersContainer.toggleClass('active', list.moreFilters);
    },
    toggleMobileForm(toggle) {
        if ( toggle ) {
            list.$body.addClass('modal-active');
        } else {
            list.$body.removeClass('modal-active');
            list.toggleFilters(false);
        }
    },
    setFiltersCount() {
        let filtersCount = 0;
        $.map(list.params, (val, name) => {
            list.mainFields.indexOf(name) === -1 && (val !== list.defaults[name] || list.disabledFields[name]) && (filtersCount++);
        });
        list.$filtersCount.html(filtersCount || '');
    },
    fillFiltersBar() { 
        $('.filter-clear-template').remove();
        let filtersCount = 0; 
        let isMobile =  functions.isMobile();
        let filters = isMobile ? list.secondaryFieldsMobile : list.secondaryFieldsDesktop;

        if (isMobile)
        {
            // list.$filterClearMobileTemplate = $('.filter-clear-mobile-template');
            // $('.filter-clear-mobile-template').remove();
            let blockMs = false;
            $.map(['ms', 'dates', 'guests'], (name) => {
                // let $newFilter = list.$filterClearMobileTemplate.clone();
                let fName = $("[name='" + name + "'").siblings('label').first().text();
                if (list.params[name] && list.params[name] != list.defaults[name])
                {
                    //if (name == 'ms') fName = $.grep(list.destinationsData, destination => destination.id == list.params.ms)[0].text;
                    if (name == 'ms') {
                        this.form.ms.guide.loading.done(() => { 
                            blockMs = true; 
                            $("[data-name='ms'").find('.filter-clear-text').html(this.form.ms.guide.selectedItem.text);
                        });
                    }
                    if (name == 'dates') fName = list.dateForFilters();
                }
                
                if (name == 'guests') 
                {
                    fName += list.guestsForFilters();
                    $("[data-name='guests'").find('.filter-clear').addClass('position-relative');
                }

                
                if (name == 'ms') 
                { 
                    fName = list.$formGuideCoordinatesPlaceholder || fName;
                    if ( ! blockMs) $("[data-name='" + name + "'").find('.filter-clear-text').html(fName); 
                }
                else  
                {
                    $("[data-name='" + name + "'").find('.filter-clear-text').html(fName); 
                }
            })
            $('.filter-clear-mobile-wrapper').on('click', function() {
                $("#filtersModal").modal('show');
            })
        }
        let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
        let exSymbol = exRates[list.defaults.currencyId].symbol;
        
        $.map(list.params, (val, name) => {
            //if (name == 'roomsExact') name = 'rooms';
            if (filters.indexOf(name) === -1 && (val !== list.defaults[name]))
            {
                if (isMobile && ['guests', 'ms', 'dates'].indexOf(name) != -1) return;
                if (['hasRegularDiscount', 'currencyId'].indexOf(name) != -1) return;
                filtersCount++;

                let $newFilter = list.$filterClearTemplate.clone();
                
                let fName = $("[name='" + name + "'").siblings('label').first().text();

                if (['roomsExact', 'bathrooms'].includes(name)) {
                    fName = $('[data-inputName="' +  name + '"]').attr('data-inputLabel');
                }

                $newFilter.attr('data-name', name);

                if (name == 'price') fName += ' ' + list.params.price.replace(',', ' ' + exSymbol + ' - ') + ' ' + exSymbol;
                $newFilter.find('.filter-clear-text').html(fName).attr('data-name', name);
                // if (isMobile){ 
                //     $newFilter.find('.filter-clear').addClass('no-before');
                // }
                $newFilter.appendTo('.filter-clear-wrapper');  
            }
        });

        filtersCount || isMobile ? $('.filters-bar').removeClass('d-none') : $('.filters-bar').addClass('d-none');

        $('.filters-count').html(filtersCount || '');

        // if (isMobile)
        // {
            filtersCount == 0 ? $('.clear-filters').addClass('d-none') : $('.clear-filters').removeClass('d-none')
            // $('.filter-clear-wrapper').on('click', function() {
            //     $("#filtersModal").modal('show');
            // })
        // }
        // else 
        // {
            $('.filter-clear-template').on('click', function(e) {
                let filter = $(this).attr('data-name');
                //if (filter === 'rooms') list.params.roomsExact = list.defaults.roomsExact;
                list.params[filter] = list.defaults[filter];
                $(this).remove();
                functions.setUrlData(list.params, true, false, list.defaults);
                functions.setFormData(list.$form, list.params);
            })
        // }

        
    },
    loadMap() {
        if ( $('.list-map').length ) {
            window.loadGoogleMaps().then(list.initMap);
        }
    },
    initMap() {
        list.$map = $('.list-map');
        list.map = new google.maps.Map(list.$map[0], {
            zoom: 10,
            center: { lat: 45.12740978317192, lng: 13.902139984375038 },
            gestureHandling: 'greedy',
            mapTypeControl: false,
            styles: [{
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' }
                ]
            }]
        });
        // only trigger mapfind when zoomout or dragend, zoomin we already have data
        list.map.addListener('zoom_changed', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            list.cluster && list.cluster.clearMarkers();
            list.lastEvent = 'zoom';
        });
        list.map.addListener('dragend', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            list.cluster && list.cluster.clearMarkers();
            list.lastEvent = 'dragend';
        });
        list.map.addListener('bounds_changed', () => {
            if ( list.suppressMapEvents ) {
                setTimeout(() => {
                    list.suppressMapEvents = false;
                });
            }
        });
        list.map.addListener('idle', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            if ( !list.lastEvent ) {
                return;
            }
            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            list.params.coordinates = sw.lat() + ',' + nw.lat() + ',' + sw.lng() + ',' + nw.lng();
            list.params._page = 1;
            
            // on drag destination clears
            if(list.params.ms) {
                list.params.ms = '';
            }
            functions.setUrlData(list.params, true, false, list.defaults);
        });

        // init info window
        list.infoWindow = new google.maps.InfoWindow({
            maxWidth: 300
        });
        list.infoWindow.addListener('domready', () => {
            // init infoWindow slider
            new Slider('#map-details-slider', {
                rubberband: false,
                loop: true,
                arrows: true,
                drag: true,
                slides: {
                    perView: 1
                },
                spacing: 0,
                duration: 1000
            });
            observer.observe();
        });
    },
    setMarkers() {
        if ( !list.map ) {
            setTimeout(list.setMarkers, 50);
            return;
        }
       // const bounds = new google.maps.LatLngBounds();
        //bounds.extend({ lat: 44.33430909374701, lng: 15.182509562684704 });
        // init each marker
        const bounds = new google.maps.LatLngBounds();
        list.markers = list.locations.map(location => {
            location.lat = +location.lat;
            location.lng = +location.lng;
            bounds.extend({ lat: location.lat, lng: location.lng });
           
            const marker = new google.maps.Marker({
                position: location,
                map: list.map,
                icon: {
                    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
                    scale: 0.6,
                    fillColor: "#28587F",
                    fillOpacity: 0.7,
                    strokeWeight: 0
                },
            });

            // marker.publicId = location.publicId;
            marker.objectId = location.objectId;
            marker.addListener('click', () => {
                list.splitDates(list.params);
                const params = {
                    objectId: marker.objectId,
                    dateFrom: list.params.dateFrom,
                    dateTo: list.params.dateTo,
                    guests: list.params.guests,
                    language: functions.getLang(),
                    template: 'map'
                };

                if ( ! list.noHover)
                {
                    $.get('/services/details/', params).then(response => {
                        if ( response.status ) {
                            list.infoWindow.setContent(response.view);
                            list.infoWindow.setPosition({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()});
                            list.infoWindow.open({
                                map: list.map,
                                shouldFocus: false
                            });
                        }
                    });
                }
            });
            return marker;
        });
        //list.map.fitBounds(bounds);
        // init cluster
        if ( !list.cluster ) {
            list.cluster = new MarkerClusterer(list.map, [], {
                minimumClusterSize: 10,
                maxZoom: 14,
                zoomOnClick: false,
                styles: [{
                    url: '/wp-content/uploads/cluster.png',
                    textSize: 14,
                    height: 40,
                    width: 40
                }]
            });
            // force cluster full zoom
            list.cluster.addListener('click', function(cluster) {
                list.map.setCenter(cluster.center_);
                list.map.fitBounds(cluster.getBounds());
                // list.map.setZoom(15);
            });
        }

        list.cluster.clearMarkers();
        list.cluster.addMarkers(list.markers);
        if ( !list.lastEvent ) {
            list.suppressMapEvents = true;
            if ( list.markers.length === 1 ) {
                list.map.setCenter(list.markers[0].position);
                list.map.setZoom(13);
            }
            else if ( list.markers.length ) {
                list.map.fitBounds(bounds, 0);
                //list.cluster.fitMapToMarkers();
            }
            else if ( list.params.coordinates ) {
                let coordinates = list.params.coordinates.split(',');
                const bounds = new google.maps.LatLngBounds();
                bounds.extend({ lat: +coordinates[0], lng: +coordinates[2] });
                bounds.extend({ lat: +coordinates[1], lng: +coordinates[3] });
                list.map.fitBounds(bounds, 0);
            }
            return;
        }
        list.lastEvent = null;
    },
    setLoadingMode() {
        if ( !list.loading ) {
            list.loading = true;
            if (list.$body.length) {
                if( ! $('.list-map').length)
                {
                    window.scrollTo({
                        top: $('body').offset().top,
                        left: 0,
                        behavior: 'instant',
                      });
                }
                list.$body.addClass('loading');
                $('.list-container').scrollTop(0);
                list.$listWrap.prepend(tplLoader).scrollTop(0);
                list.$listWrap.scrollTop(0); // mobile
                list.$list.scrollTop(0);
                list.infoWindow && list.infoWindow.close();
            } else {
                list.$form
                    .find('.form-submit').prop('disabled', true)
                    .find('i').addClass('fa-spinner fa-spin fa-lg');
            }
        }
    },
    unsetLoadingMode() {
        if ( list.loading ) {
            list.loading = false;
            list.$body.removeClass('loading').find('.list-loader').remove();
        }
    },
    find() {
        // init list
        if ( !list.$list ) {
            list.$list = $('.list');
            if ($('.list-items').length) list.$list = $('.list-items');
            
            list.list = list.$list[0];

            //console.log(list.$list.closest('.list-wrap'));
            list.$listWrap = list.$list.closest('.list-wrap');
        }
        list.setLoadingMode();
        let ajaxId = ++list.loadId;
        if ($('.list-map').length) list.mapFind(ajaxId);
        let submitParams = $.extend({}, list.params);
        // so after any map event destinaton search filed clears
        if(submitParams.coordinates) submitParams.ms = null;
        this.splitDates(submitParams);
        if(submitParams.objectName)  
        {
            submitParams = $.extend({}, {
                objectName: submitParams.objectName, 
                guests: submitParams.guests, 
                dateFrom: submitParams.dateFrom,
                dateTo: submitParams.dateTo,
                language: submitParams.language,
                perPage: submitParams.perPage,
                _page: submitParams._page,
                hasDiscount: submitParams.hasDiscount,
            })
        }
        if (submitParams.price && submitParams.price !== this.defaults.price)
        {
            let prices = list.convertPriceSliderToEuro(submitParams.price);
            submitParams.priceFrom  = prices[0];
            submitParams.priceTo    = prices[1];
            submitParams.price = null;
        }

        if (submitParams.hasDiscount == 1)
        {
            submitParams.hasRegularDiscount = 1;
        }

        // submitParams.currencyIdTo = submitParams.currencyIdTo = null;
        // if we have objectName we only need object name, guests and period (from - to)
        $.get('/services/list/', submitParams).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            response = JSON.parse(response);
            list.total = response.total;
            list.$list[0].innerHTML = response.html + pagination({
                currentPage: list.params._page,
                total: list.total,
                perPage: list.params.perPage
            });
            //functions.initCompare();
           // list.setResultsText();
            list.noHover = false;
            list.domInits();
            list.unsetLoadingMode();
        });
    },
    setResultsText() {
        let maxResults = list.params._page * 10;
        list.$shownItems.html(
            (maxResults - 9) +
            ' - ' +
            (maxResults > list.total ? list.total : maxResults)
        );
        list.$total.html(list.total);
    },
    domInits() {

        // init tooltips
        //list.$list.find('[data-toggle="tooltip"]').tooltip();
        // slider list item init
        /*list.$list.find('.list-item-slider').lightSlider({
            item: 1,
            mode: 'slide',
            pager: false,
            slideMargin: 0,
            loop: true,
            speed: 500,
            prevHtml: '<i class="fas fa-chevron-left"></i>',
            nextHtml: '<i class="fas fa-chevron-right"></i>'
        });
        lozadObserver.observe();*/

        let villasSlider = [];
        $('[id^=villa-card-slider]').each((i, elem) => {
            villasSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                drag: true,
                controls: true,
                slides: {
                    perView: 1
                },
                spacing: 0,
                duration: 1000,
                autoplay: 0,
                pauseOnHover: true,
                pager: false, 
                autoLoadSlides: 1      
            });
        });

        if ( ! $('list-map').length) 
        {
            $('.show-on-desktop').removeClass('d-none');
            const observerVillas = lozad('.villas-lozad', {
                rootMargin: '100px 100px',
                loaded: el => {
                    let villasSlider = [];
                    $(el).find('[id^=villa-card-slider]').each((i, elem) => {
                        const length = $(elem).children('.keen-slider__slide').length;
                        villasSlider[i] = new Slider('#' + $(elem).attr('id'), {
                            rubberband: false,
                            loop: false,
                            arrows: true,
                            drag: true,
                            controls: true,
                            slides: {
                                perView: 1
                            },
                            spacing: 0,
                            duration: 1000,
                            autoplay: 0,
                            pauseOnHover: true,
                            pager: false,   
                            autoLoadSlides: 2,
                                
                        });
                    });
                        $(el).triggerHandler('lozadLoaded');
                    }
                });
            observerVillas.observe();
        }

        

        list.$filterClearTemplate = $('.filter-clear-template');

        if (list.$filterClearTemplate)
        {
            list.$filterClearTemplate.remove(); 
        }

        let $dropdown = $(".dropdown-sort-by");
        $dropdown.find('.dropdown-item').on('click', function (e) {
            e.preventDefault();
            list.params._page = 1;
            list.params.sortBy = $(e.currentTarget).attr('href');
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true, false, list.defaults);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        // premješteno ovdje jer filter bar ima clear-filters, a on se inicijalizira nakon dohvaćanja liste
        $('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {};
            let filters = functions.isMobile() ? list.secondaryFieldsMobile : list.secondaryFieldsDesktop;
            $.map(list.params, (value, key) => {
                if ( filters.indexOf(key) === -1 ) {

                    if(functions.isMobile() && ['guests', 'ms', 'dates'].indexOf(key) != -1)  return;
                    
                    //if (key == 'rooms' && list.params.roomsExact) key = 'roomsExact';
                    if ( list.params[key] && list.params[key] != list.defaults[key] ) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            functions.setFormData(list.form, formData);
            list.toggleFilters(false);
            if ( changed ) {
                if ( ! e.target.classList.contains('clear-filters-mobile') ) {
                    list.onChange();
                }
                if ( !list.$body.length ) {
                    list.$form.submit();
                }
            }
        });

        if (list.params.sortBy) {
            let text = $dropdown.find(".dropdown-item[href='"+list.params.sortBy+"']").html();
            $dropdown.find(".btn").html(text);
        }

        list.prices();
        list.fillFiltersBar();
        observer.observe();
    },
    mapFind(ajaxId) {
        let params = Object.assign({}, list.params);
        if ( list.lastEvent ) {
            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            params.coordinates = list.params.coordinates = sw.lat() + ',' + nw.lat() + ',' + sw.lng() + ',' + nw.lng();
        } else {
            if ( !params.ms ) {
                //params.destination = '8';
            }
        }
        let submitParams = $.extend({}, list.params);
        // so after any map event destinaton search filed clears
        if(submitParams.coordinates) submitParams.ms = null;
        this.splitDates(submitParams);
        // if we have objectName we only need object name, guests and period (from - to)
        if(submitParams.objectName)  
        {
            submitParams = $.extend({}, {
                objectName: submitParams.objectName, 
                guests: submitParams.guests, 
                dateFrom: submitParams.dateFrom,
                dateTo: submitParams.dateTo,
                language: submitParams.language,
                perPage: submitParams.perPage,
                _page: submitParams._page
            })
        }

        if (submitParams.price && submitParams.price !== this.defaults.price)
        {
            let prices = list.convertPriceSliderToEuro(submitParams.price)
            submitParams.priceFrom  = prices[0];
            submitParams.priceTo    = prices[1];
            submitParams.price = null;
        }
        $.get('/services/map/', submitParams).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            list.locations = JSON.parse(response);
            list.setMarkers();
        });
    },
    paginate(page) {
        if ( page != list.params._page ) {
            list.params._page = page;
        }
        if ( list.$body.length ) {
            functions.setUrlData(list.params, list.$body.length, false, list.defaults);
        } else {
            list.paginated = true;
            list.$form.submit();
        }
    },
    registerSearchOpenEvents()
    {
        let home = list.$form.hasClass('form-hash');
        if (home)
        {
            $('#select2-dest').on('select2:select', function (e) {
                $('.datepicker-range')[0]._flatpickr.open();
    
                $('.datepicker-range')[0]._flatpickr.config.onClose.push(function() {
                    $('.simple-guests').dropdown('toggle');
                })
              });
        }
        else 
        {
            $('#select2-dest').on('select2:select', function (e) {
                if (! list.params.dates) $('.datepicker-range')[0]._flatpickr.open();
            });
        }
    },

    prices()
    {
        // var id = functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1;
        // if(id)
        // {
        //     let all = JSON.parse($('.currency-selected').attr('data-currencies'));
        //     $('.currency-selected .currencyCode').text(all[id]);
            
        // $('.currency-change').each( (i, elem) => {
        //     if(elem.id == id) $(elem).addClass('active');
        // });
        // }  
        // if(id && id != 1 && id != 2)
        // {
        //     let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
        //     let ex = exRates[id];
        //     $('.price').each( (id, el) => {
        //         let price = $(el).attr('data-priceEuro');
        //         let exPrice = new Intl.NumberFormat('de-DE').format(Math.round(ex['rate'] * price));
        //         $(el).text(exPrice);
        //     });
        // }
    },
    dateForFilters()
    {
        let val = list.params.dates.split(' - ');
        let dateFrom = new Date(val[0]);
        let dateTo = new Date(val[1]);
        dateFrom = dateFrom.getDate() + '/' + (dateFrom.getMonth() + 1);
        dateTo = dateTo.getDate() + '/' + (dateTo.getMonth() + 1);
        return dateFrom + ' - ' + dateTo;
    },

    guestsForFilters()
    {
        let val = [];
        val = list.defaults.guests.split(',');
        if(list.params.guests) {val = []; val = list.params.guests.split(',');}
        let guests = parseInt(val[0]) + parseInt(val[1]);
        return ': ' +  guests;
    },

    setPriceSliderAndSliderCurrency()
    {
        function rangeSliderValueFunc($value, prefix, suffix, values) {
            let value = (suffix == '€' ? functions.formatMoney(+values[0], 0, ',') + ' ' : +values[0]) + suffix;
            if ( values[1] !== undefined ) {
                value += ' - ' + ((suffix == '€' ? functions.formatMoney(+values[1], 0, ',')+ ' ' : +values[1]) + suffix);
            }
            $value.html(prefix + value);
        }
    
        const customrangeSliderValueFuncs = {
            rangeYearValue: ($value, values, config) => {
                let min = +values[0];
                if ( min == config.range.min ) {
                    min = '< ' + min;
                }
                $value.html(min + ' - ' + +values[1]);
            }
        };

        list.defaults.currencyId = functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1;

        if(list.defaults.currencyId && $('.currency-selected').length)
        {
            let key = 'curr'+list.defaults.currencyId;
            let rate = list.defaults.currencyRate = 1;
            let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
            let ex = exRates[list.defaults.currencyId];
            if (functions.getCookie(key))
            {
                rate = list.defaults.currencyRate = functions.getCookie(key);

                let exPriceTo = Math.round(20000 / rate);
                list.defaults.price = '0,' + String(exPriceTo);
            }
        }

        let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
        let exSymbol = exRates[list.defaults.currencyId].symbol;

        let priceRange = list.defaults.price.split(',');
        $('.range-slider').each((i, elem) => {
            const $elem = $(elem);
            const $input = $(elem).find('input');
            const min = +priceRange[0] || 0;
            const max = +priceRange[1] || 1000;
            const start = +$elem.attr('data-start') || min;
            const end = +$elem.attr('data-end') || null;
            const step = +$elem.attr('data-step') || 1;
            const suffix = ' ' + exSymbol || $elem.attr('data-value-suffix') || '';
            const prefix =  $elem.attr('data-value-prefix') || '';
            const valueFunc = $elem.attr('data-value-func') || null;
            const config = {
                start: [start],
                connect: true,
                step: step,
                range: {
                    'min': min,
                    'max': max
                }
            };
            end && (config.start[1] = end);
            noUiSlider.create(elem, config);
            $input[0].noUiSlider = elem.noUiSlider;
    
            const $value = $($elem.parent()).find('.range-slider-value');
    
            elem.noUiSlider.on('update', values => {
                if ( valueFunc && customrangeSliderValueFuncs[valueFunc] ) {
                    customrangeSliderValueFuncs[valueFunc]($value, values, config);
                } else {
                    rangeSliderValueFunc($value, prefix, suffix, values);
                }
            });
            elem.noUiSlider.on('change', () => {
                let value = elem.noUiSlider.get();
                value = $.isArray(value) ? value : [value];
                value = value.map(v => +v);
                value = value.join(',');
                $input.val(value).trigger('change');
            });
        });
    },

    convertPriceSliderToEuro(price)
    {
        price = price.split(',');

        let priceFrom = Math.round(price[0] * list.defaults.currencyRate);
        let priceTo = Math.round(price[1] * list.defaults.currencyRate);
        return [priceFrom, priceTo];

    }
    
};

$(() => {
    list.init();
    list.loadMap();
});